import Nullstack from 'nullstack';
export default function IconBrain({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brain",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M15.5 13a3.5 3.5 0 0 0 -3.5 3.5v1a3.5 3.5 0 0 0 7 0v-1.8"
  }), "   ", Nullstack.element("path", {
    d: "M8.5 13a3.5 3.5 0 0 1 3.5 3.5v1a3.5 3.5 0 0 1 -7 0v-1.8"
  }), "   ", Nullstack.element("path", {
    d: "M17.5 16a3.5 3.5 0 0 0 0 -7h-.5"
  }), "   ", Nullstack.element("path", {
    d: "M19 9.3v-2.8a3.5 3.5 0 0 0 -7 0"
  }), "   ", Nullstack.element("path", {
    d: "M6.5 16a3.5 3.5 0 0 1 0 -7h.5"
  }), "   ", Nullstack.element("path", {
    d: "M5 9.3v-2.8a3.5 3.5 0 0 1 7 0v10"
  }), " ");
}